import { _Constructor as Constructor } from '@angular/material/core';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function WithCompareByIdFn<T extends Constructor<{}>>(Base: T = (class { }) as T) {
  return class extends Base {

    compareByIdFn(a: { id: string }, b: { id: string }) {

      return a && b && a.id === b.id;
    }
  };

}
